import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';

@Component({
  selector: 'app-notes-form',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class NotesFormComponent implements OnInit, OnDestroy {
  @Input() vessel: Vessel;
  vesselNotes: Partial<Vessel>;
  constructor() {}

  ngOnInit() {}

  ngOnDestroy(): void {}

  setVesselNotes() {
    this.vesselNotes = {
      id: this.vessel.id,
      notes: this.vessel.notes,
      instructionsAndRules: this.vessel.instructionsAndRules,
    };
  }
}
